/**
 * @bref    Fonctions JavaScripts communes pour la validation.
 * @remark  Fichier appelé au début.
 */

//#####################################################
// FUNCTIONS GLOBALES DE VALIDATION
//#####################################################

// Function to validate the email address
window.isValidEmail = function(email) {
    let pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
};

// Function to execute a callback function after inactivity period
window.inactivityTimeout = function(callback, timeout) {
    if (typeof(callback) == 'function') {
        let time;
        let resetTimer = function() {
            clearTimeout(time);
            time = setTimeout(callback, timeout);
        };
        // DOM Events
        document.onkeydown = resetTimer;
        document.onmousemove = resetTimer;
        document.ontouchmove = resetTimer;
        resetTimer();
    }
};
